import React, {useEffect, useState} from "react";
import {Loader, Title} from "../components";
import FormButton from "../forms/FormButton";
import ShowPopupConfig from "./ShowPopupConfig";
import EditPopupConfig from "./EditPopupConfig";
import map from "lodash/map"

export default function CmpPopupConfig({cmpConfig, updateCmpConfig, isLoading, isSuccess, params = {}}) {
  const [editable, setEditable] = useState(false)
  const [submitButtonProps, setSubmitButtonProps] = useState({})
  const [preparedCmpConfigContent, setPreparedCmpConfigContent] = useState()
  const handleSuccess = () => setEditable(false)
  const loaderProps = { success: (!isLoading && isSuccess), error: (!isLoading && !isSuccess) }

  const preparedContent = () => {
    const languages = cmpConfig.inheritedConfig?.languages || cmpConfig.languages
    return languages?.map( language => {
      const cmpConfigAttributes = cmpConfig.content?.filter(el => el.language == language)
      const inheritedCmpConfigAttributes = cmpConfig.inheritedConfig?.content?.filter(el => el.language == language)

      return {
        language,
        attributes: map(inheritedCmpConfigAttributes || cmpConfigAttributes, 'name').map(name => ({
          name,
          content: cmpConfigAttributes?.find(el => el.name == name)?.content,
          inheritedContent: inheritedCmpConfigAttributes?.find(el => el.name == name)?.content
        }))
      }
    })
  }

  useEffect(() => {
    setPreparedCmpConfigContent(preparedContent(cmpConfig))
  }, [cmpConfig])

  return (
    <>
      <Title group={false}>
        {!editable && <FormButton edit onClick={() => setEditable(true)}/>}
        {editable && <FormButton submit {...submitButtonProps}/>}
        {editable && <FormButton cancel onClick={() => setEditable(false)}/>}
      </Title>
      <Loader {...loaderProps}>
        {editable && <EditPopupConfig cmpConfig={cmpConfig}
                                      setSubmitButtonProps={setSubmitButtonProps}
                                      onSubmit={updateCmpConfig}
                                      params={params}
                                      handleSuccess={handleSuccess}
                                      preparedCmpConfigContent={preparedCmpConfigContent}/>}
        {!editable && <ShowPopupConfig cmpConfig={cmpConfig}
                                       preparedCmpConfigContent={preparedCmpConfigContent}/>}
      </Loader>
    </>
  )
}
